import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { useUDData } from '@udemy/ud-data';
import { UnreadActivityNotificationsBadge, UnreadMessagesBadge, UnseenCreditsBadge } from '../../../badges.react-component';
import { useHeaderStore } from '../../../hooks/use-header-store';
import { MobileNavItem, MobileNavL1Nav, MobileNavSection, MobileNavSectionHeading } from '../mobile-nav.react-component';
export const MobileStudentProfileNav = observer(() => {
  const udData = useUDData();
  const udConfig = udData.Config;
  const {
    gettext
  } = useI18n();
  const headerStore = useHeaderStore();
  const {
    urls
  } = headerStore;
  function alertsSection() {
    return renderSection(gettext('Alerts'), /*#__PURE__*/React.createElement(MobileNavSection, null, udConfig.features.notifications && /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.VIEW_NOTIFICATIONS,
      icon: /*#__PURE__*/React.createElement(UnreadActivityNotificationsBadge, null)
    }, gettext('Notifications')), udConfig.brand.is_messaging_enabled && /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.MESSAGES,
      icon: /*#__PURE__*/React.createElement(UnreadMessagesBadge, null)
    }, gettext('Messages')), !headerStore.isPersonalPlanSubscriber && udConfig.features.wishlist && /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.WISHLIST
    }, gettext('Wishlist'))));
  }
  function accountSection() {
    return renderSection(gettext('Account'), /*#__PURE__*/React.createElement(MobileNavSection, null, /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.ACCOUNT
    }, gettext('Account settings')), !udConfig.brand.has_organization && /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.PAYMENT_METHODS
    }, gettext('Payment methods')), renderSubscriptionBlock(), !udConfig.brand.has_organization && /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.CREDITS,
      icon: /*#__PURE__*/React.createElement(UnseenCreditsBadge, null)
    }, gettext('Udemy credits')), !udConfig.brand.has_organization && /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.PURCHASE_HISTORY
    }, gettext('Purchase history'))));
  }
  function profileSection() {
    const {
      user
    } = headerStore.userSpecificContext;
    return renderSection(gettext('Profile'), /*#__PURE__*/React.createElement(MobileNavSection, null, !!(udConfig.brand.is_profile_functions_enabled && udConfig.brand.is_user_profiles_public && user.url) && /*#__PURE__*/React.createElement(MobileNavItem, {
      href: user.url,
      target: "_blank",
      rel: "nofollow noopener noreferrer"
    }, gettext('Public profile')), /*#__PURE__*/React.createElement(MobileNavItem, {
      href: urls.EDIT_PROFILE
    }, gettext('Edit profile')), /*#__PURE__*/React.createElement(MobileNavItem, {
      href: user.logout_url
    }, gettext('Log out'))));
  }
  function renderSubscriptionBlock() {
    const {
      urls,
      userSpecificContext
    } = headerStore;
    if (userSpecificContext.isSubscriptionAware) {
      return /*#__PURE__*/React.createElement(MobileNavItem, {
        href: urls.SUBSCRIPTION_MANAGEMENT
      }, gettext('Subscriptions'));
    }
    return null;
  }
  function renderSection(title, list) {
    if (React.Children.toArray(list.props.children).filter(Boolean).length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, title), list);
  }
  const {
    user
  } = headerStore.userSpecificContext;
  if (!user || !user.id) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-student-profile"
  }, alertsSection(), accountSection(), profileSection());
});
//# sourceMappingURL=mobile-student-profile-nav.react-component.js.map